import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { FormModule } from 'app/company/form/form.module';
import { FuseTranslationLoaderService } from 'app/services/translation-loader.service';
import { AddressDisplayerModule } from 'app/shared/address-displayer/address-displayer.module';
import { LocalizedStringPipeModule } from 'app/shared/localized-string-pipe/localized-string-pipe.module';
import { SharedModule } from 'app/shared/shared.module';
import { BoardMemberSearchModule, LabelValueModule, OdqToolboxModule } from 'odq-toolbox';
import { locale as english } from './i18n/en';
import { locale as french } from './i18n/fr';
import { PageHeaderComponent } from './page-header/page-header.component';
import { PublicMemberInfoV2Component } from './public-member-info-v2/public-member-info-v2.component';
import { PublicMemberInfoComponent } from './public-member-info/public-member-info.component';
import { PublicMemberSearchComponent } from './public-member-search.component';
import { PublicMemberSearchState } from './store/public-member-search.state';

@NgModule({
  declarations: [PublicMemberSearchComponent, PublicMemberInfoComponent, PublicMemberInfoV2Component, PageHeaderComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    TranslateModule,
    MatIconModule,
    MatInputModule,
    BoardMemberSearchModule,
    LabelValueModule,
    OdqToolboxModule,
    MatCardModule,
    MatButtonModule,
    LocalizedStringPipeModule,
    AddressDisplayerModule,
    NgxsModule.forFeature([PublicMemberSearchState]),
  ],
  exports: [PublicMemberSearchComponent]
})
export class PublicMemberSearchModule {
  constructor(translationLoader: FuseTranslationLoaderService) {
    translationLoader.loadTranslations(english, french);
  }
}
